import { CustomModal } from "../../../../../../../../../../components/ui/CustomModal/CustomModal";
import { useSetZIndex } from "../../../../../../../../../../hooks/useSetZIndex";
import { TariffCard } from "../TariffCard/TariffCard";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { Button } from "../../../../../../../../../../components/ui/Buttons/Button/Button";
import { useTranslation } from "../../../../../../../../../../hooks";
import "./ChangeTariffModal.scss";

const PaymentBlock = () => {
  const { cabinet: { orders: { residential: { paymentNotice, recharge, andRepeat } } } } = useTranslation();

  return (
    <div className="tariff-modal__payment-block">
      <IconSvg tag="cardsLarge"/>
      <div className="tariff-modal__payment-text">
        {paymentNotice} <span>{recharge}</span> {andRepeat}
      </div>
    </div>
  );
};

export const ChangeTariffModal = () => {
  useSetZIndex(".cabinet", "999");

  const { cabinet: { orders: { residential: {
    changeTariffTitle, info, submitChange, cancel
  } } } } = useTranslation();

  return (
    <CustomModal
      open={true}
      styles={{ zIndex: "999999999" }}
    >
      <div className="tariff-modal">
        <div className="tariff-modal__description">
          <div className="tariff-modal__aside">
            <div className="tariff-modal__title">{changeTariffTitle}</div>
            <div className="tariff-modal__info">
              {info}
            </div>
          </div>
          <div className="media__min-width-993">
            <PaymentBlock/>
          </div>
        </div>
        <div className="tariff-modal__cards-container">
          <div className="tariff-modal__cards">
            <TariffCard/>
            <TariffCard/>
            <TariffCard/>
            <TariffCard/>
            <TariffCard/>
            <TariffCard/>
          </div>
          <div className="media__max-width-992">
            <PaymentBlock/>
          </div>
          <div className="tariff-modal__actions">
            <Button>{cancel}</Button>
            <Button tab="confirm">{submitChange}</Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};
